import echarts from "echarts/lib/echarts";
import React, { useEffect, useRef } from "react";
import { bind, clear } from "size-sensor";
import useWindowWidth from "../../hooks/useWindowWidth";

function useWindowWidthChange(callback) {
  const width = useWindowWidth();
  const prev = useRef();
  useEffect(() => {
    if (width !== prev.current) {
      prev.current = width;
      callback();
    }
  });
}

function Grafica({
  option,
  events,
  echartsOptions,
  initialAnimation = true,
  // esto se usa en las gráfica de pie para que la animación inicial salga bien,
  // si no hay un delay antes de llamar a echarts la animación se corta.
  animationDelay = 0,
  ...rest
}) {
  const chartRef = useRef();
  const divRef = useRef();
  useEffect(() => {
    chartRef.current = echarts.init(divRef.current, null, echartsOptions);
    if (events) bindEvents(chartRef.current, events);
    return () => chartRef.current?.dispose();
  }, [divRef, events, chartRef, echartsOptions]);

  useEffect(() => {
    bind(divRef.current, () => chartRef.current?.resize());
    return () => divRef.current && clear(divRef.current);
  }, []);

  //resizing both on windowwith change and size-sensor is overkill, size-sensor shouldn't be needed, but just in case
  // useWindowWidthChange(() => {
  //   setTimeout(() => {
  //     chartRef.current.resize();
  //   }, 300);
  // });
  
  const firstRunRef = useRef(false);
  useEffect(() => {
      const clearOptions = {
        replaceMerge: ['xAxis', 'yAxis', 'series']
      }
    if (!firstRunRef.current) {
      if (animationDelay !== 0) {
        setTimeout(() => {
          try{
            chartRef.current.setOption(option, true);
          }catch{
            //https://github.com/apache/echarts/issues/9165
            console.log("getWidth")
          }
          firstRunRef.current = true;
        }, animationDelay);
      } else {
        firstRunRef.current = true;
        if (initialAnimation) {
          chartRef.current.setOption(option, true);
        } else {
          chartRef.current.setOption({ ...option, animation: false });
        }
      }
    } else {
      chartRef.current.setOption(option, true);
    }
  }, [chartRef, option, initialAnimation, animationDelay]);
  return <div ref={node => (divRef.current = node)} {...rest} />;
}

export default Grafica;

function bindEvents(element, events) {
  for (const [event, fn] of Object.entries(events)) {
    element.on(event, x => {
      fn(x, element);
    });
  }
}
